export default __webpack_public_path__ + "static/media/home.e7a109b5.svg";